// Template281: Pekín - Consejos p.2 (ConsejosPekinPagina2.jsx)
// Cabecera, intro, lista tips (icono + texto) con borde rosa, sticker.

import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";

const Template281 = ({
	backgroundColor,
	textColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;
	const contentColor = textColor || "#444";

	const headerText = page?.texts?.[0]?.content;
	const intro = page?.texts?.[1]?.content;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found?.src) return found.src;
		}
		return undefined;
	};
	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const sticker = getImageSrc("sticker");
	const logoImage = getCanvasImageUrl("logo");
	const tips = Array.isArray(page?.data?.tips)
		? page.data.tips
		: Array.isArray(page?.data?.data?.tips)
			? page.data.data.tips
			: [];
	const actualHeaderColor = headerBackgroundColor || "#8c1d18";

	const estiloP = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		color: contentColor,
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				height: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				color: contentColor,
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *:not([data-template-header])": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
					color: "inherit",
				},
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 1,
				}}
			>
				{headerText}
				{logoImage && !isSmallScreen && (
					<Box
						component="img"
						src={logoImage}
						alt="logo"
						sx={{
							width: 66,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</Box>

			<Box
				data-block-id="text-1"
				sx={{
					padding: "0 16px 20px",
					display: "flex",
					flexDirection: "column",
					gap: 1.5,
					position: "relative",
					flex: 1,
					overflow: "auto",
					marginTop: 2,
				}}
			>
				{sticker && isSmallScreen && (
					<Box
						component="img"
						src={sticker}
						alt=""
						sx={{ width: 85, position: "absolute", bottom: 10, right: 10 }}
					/>
				)}
				{tips.map((tip, idx) => (
					<Box
						key={tip.texto}
						data-block-id={`text-${idx + 2}`}
						sx={{
							backgroundColor: "#fff",
							borderRadius: "12px",
							padding: "12px 14px",
							display: "flex",
							alignItems: "center",
							gap: 1.25,
							border: "2px solid #e8b4b4",
						}}
					>
						<Box component="span" sx={{ fontSize: 18 }}>
							{tip.icono}
						</Box>
						<Box component="span" sx={{ fontSize: 13, color: contentColor }}>
							{tip.texto}
						</Box>
					</Box>
				))}
				{sticker && !isSmallScreen && (
					<Box
						component="img"
						src={sticker}
						alt=""
						sx={{ width: 95, position: "absolute", bottom: 20, right: 10 }}
					/>
				)}
			</Box>
		</Box>
	);
};

Template281.thumbnail = "/images/template-1.png";
export default Template281;
